export enum FieldLabelConstants {
  NationalProviderIdentifier = 'National Provider Identifier (NPI)',
  Active = 'Active',
  BodyPartCondition = 'Body Part(s)/Condition(s)',
  CaseEstablished = 'Case Established',
  ClaimAdminClaimNumber = 'Claim Admin Claim #',
  ClaimantFirstName = 'Claimant First Name',
  ClaimantMiddleName = 'Claimant Middle Name',
  ClaimantLastName = 'Claimant Last Name',
  CreatedDate = 'Created',
  CreatedOnDate = 'Created On',
  DateOfBirth = 'Date of Birth',
  DateOfInjury = 'Date of Injury',
  EffectiveDate = 'Effective Date',
  Email = 'Email',
  EmployerAddress = 'Employer Address',
  EmployerFein = 'Employer FEIN',
  EmployerName = 'Employer Name',
  EndDate = 'End Date',
  HealthCareProvider = 'Health Care Provider',
  HealthCareProviderId = 'Health Care Provider ID',
  InsurerAddress = 'Insurer Address',
  InsurerFein = 'Insurer FEIN',
  InsurerFeinMustBeNineDigits = 'Insurer FEIN must be nine digits.',
  LicenseNumber = 'License #',
  MedicalSupplierFein = 'Medical Supplier FEIN',
  MedicalSupplierName = 'Medical Supplier Name',
  MedicalSupplierType = 'Medical Supplier Type',
  MedicalSupplierNpi = 'Medical Supplier National Provider Identifier (NPI)',
  MTG = 'MTG',
  MTGReference = 'MTG Reference Code',
  MTGSite = 'MTG Site',
  MTGReferenceDescription = 'MTG Reference Description',
  PatientAddress = 'Patient Address',
  PatientDateOfBirth = 'Patient DOB',
  PatientName = 'Patient Name',
  PatientSsn = 'Patient SSN',
  PatientSsnLast4 = 'Last four of Patient SSN',
  SaveHealthCareProviderSpecialty = 'Save Health Care Provider Specialty',
  Ssn = 'SSN',
  StartDate = 'Start Date',
  SubmittedOnBehalfOf = 'Submitted On Behalf Of',
  TpaFein = 'TPA FEIN',
  UpdatedDate = 'Updated',
  WcbCaseNumber = 'WCB Case #',
}
